import {TONE_NAMES} from './palettes';

/**
 * Resolve a tone name to a valid tone key.
 *
 * @param {string|undefined} tone     — requested tone
 * @param {Object}  [opts]
 * @param {string}  [opts.fallback]   — fallback tone (default: "normal")
 * @returns {string} — one of "soft" | "normal" | "strong"
 */
export function resolveTone(tone, {fallback = 'normal'} = {}) {
	if (tone && TONE_NAMES.includes(tone)) return tone;
	return fallback;
}
